
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.5 4a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"}}),_c('path',{attrs:{"d":"M6.5 1.5a5 5 0 015 5c0 2.271-3.383 7.967-4.583 9.777a.5.5 0 01-.834 0C4.883 14.467 1.5 8.77 1.5 6.5a5 5 0 015-5z"}})])])
          )
        }
      }
    